<template>
<div class="summaryTable">
    <div>
        <div class="columns is-mobile">
            <div class="column is-3">
                <i class="fas fa-user"></i>
            </div>
            <div class="column is-1">
                GP
            </div>
            <div class="column is-1">
                <i class="fas fa-award winner"></i>
            </div>
            <div class="column is-1">
                Loss
            </div>
            <div class="column is-1">
                <i class="fas fa-bullseye"></i>
            </div>
            <div class="column is-1">
                Avg
            </div>
            <div class="column is-2">
                Total
            </div>
        </div>
        <div v-for="(player, index) in this.players" :player="player" :key="player.player" class="columns is-mobile">
            <div class="column is-3 col_adjust">
                <label  v-bind:for="player.id">{{  player.test  }}
                    <em>{{ player.given_name || player.name}} </em>
                </label>
            </div>
            <div class="column is-1 col_adjust">
                <span>{{ player.gp }}</span>
            </div>
            <div class="column is-1 col_adjust">
                <span>{{ player.wins }}</span>
            </div>
            <div class="column is-1 col_adjust">
                <span>{{ player.loss }}</span>
            </div>
            <div class="column is-1 col_adjust">
                <span v-if="player.bullseyes != 0">
                    <span>{{ player.bullseyes }}</span>
                </span>
            </div>
            <div class="column is-1 col_adjust">
                <span>{{ player.average }}</span>
            </div>
            <div class="column is-2 col_adjust">
                <span>{{ player.total }}</span>
            </div>
        </div>
    </div>
    <br/>
</div>
</template>

<style scoped>
.summaryTable, h2, .is-size-4 {
    color: black !important;
}
.summaryTable .columns .column {
    border: solid black 1px;
    padding: 1px;
    padding-left: 3px;
    font-size: 0.8em;
}
</style>

<script>
export default {
  name: "SummaryTable",
  props: {
    summary: null,
    players: null,
    isFinals: false
  },
}
</script>